<template>
  <el-dialog custom-class="transformer-package-select-container dialog-size-middle"
             title="データ変換の選択"
             :top="0"
             :modal="false"
             append-to-body="true"
             :visible.sync="visible"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="transformer-package-select-container-inner">
      <el-menu class="transformer-package-select-container" mode="vertical" unique-opened="true"
               :default-active="selectedTransformerPackage ? selectedTransformerPackage.packageId : ''">
        <el-menu-item :index="transformerPackage.packageId" v-for="transformerPackage in transformerPackages"
                      @click="onClickMenuItem(transformerPackage)">
          <span slot="title">{{ transformerPackage.packageName }}</span>
        </el-menu-item>
      </el-menu>
      <div class="transformer-package-select-main-container">
        <h2>{{selectedTransformerPackage ? getPackageName(selectedTransformerPackage.packageId) : ''}}</h2>
        <p v-html="selectedTransformerPackage ? $options.filters.html_format(getPackageTip(selectedTransformerPackage.packageId)) : ''"></p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible=false">キャンセル</el-button>
      <el-button type="primary" @click="onClickSelect">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { TransformerPackage } from '../../../../defines/transformer'
import CommonUtil from '../../../../utils/common'

export default {
  name: 'TransformerPackageSelectDialogCmp',
  components: {},
  props: {
    transformerPackages: [],
    selectedTransformerPackage: TransformerPackage
  },
  data () {
    return {
      visible: true

    }
  },
  methods: {
    getPackageName (packageId) {
      if (CommonUtil.isNotEmpty(this.selectedTransformerPackage.packageName)) {
        return this.selectedTransformerPackage.packageName
      } else {
        return this.transformerPackages.find(
          transformerPackage => transformerPackage.packageId === packageId).packageName
      }
    },
    getPackageTip (packageId) {
      if (CommonUtil.isNotEmpty(this.selectedTransformerPackage.tip)) {
        return this.selectedTransformerPackage.tip
      } else {
        return this.transformerPackages.find(transformerPackage => transformerPackage.packageId === packageId).tip
      }

    },
    onClickMenuItem (transformerPackage) {
      this.selectedTransformerPackage = transformerPackage
      this.$forceUpdate()
    },
    onClickSelect () {
      this.visible = false
      this.$emit('select', this.selectedTransformerPackage)
    }
  }
}
</script>

<style type="scss" scoped>
  .transformer-package-select-container-inner {
    display: flex;
    flex-direction: row;
    height: 500px;
  }

  .transformer-package-select-container-inner > .transformer-package-select-container {
    flex-shrink: 0;
    width: 330px;
    overflow-y: scroll;
  }

  .transformer-package-select-container-inner > .transformer-package-select-main-container {
    flex-shrink: 0;
    flex-grow: 1;
    padding-left: 24px;
    max-width: 630px;
    overflow-y: auto;
  }

  .transformer-package-select-container-inner > .transformer-package-select-main-container > h2 {
    margin: 0;
  }

  .transformer-package-select-container-inner > .transformer-package-select-main-container > p {
    margin-top: 0;
    word-wrap: break-word;
  }

  .transformer-package-select-container-inner > .transformer-package-select-main-container > .transformer-package-select-main-img-container {
    text-align: center;
    padding: 16px 0;
  }

  .transformer-package-select-container-inner > .transformer-package-select-main-container > .transformer-package-select-main-img-container > img {
    width: 480px;
  }
</style>



// WEBPACK FOOTER //
// src/components/model/train/dialogs/transformer-package-select.vue